import React from 'react';

var SvgTaxFilledIcon = function SvgTaxFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.133 3.517c-.131-.547.332-1.017.895-1.017h3.944c.563 0 1.026.47.895 1.017-.225.939-.716 1.72-1.355 2.203a5.307 5.307 0 0 1 3.49 3.315l1.108 3.13c.922 2.603-1.008 5.335-3.77 5.335h-4.68c-2.762 0-4.692-2.732-3.77-5.335l1.108-3.13a5.307 5.307 0 0 1 3.49-3.315c-.639-.484-1.13-1.264-1.355-2.203Zm5.559 5.791a.625.625 0 0 1 0 .884l-4.5 4.5a.625.625 0 1 1-.884-.884l4.5-4.5a.625.625 0 0 1 .884 0Zm-4.692 1.692a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }));
};
SvgTaxFilledIcon.displayName = "TaxFilledIcon";

export { SvgTaxFilledIcon as S };
